/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RoutineId } from "../../commons/types/RoutineId";
import { RunbookId } from "../../commons/types/RunbookId";
import { RoutineType } from "./RoutineType";
export const Routine = core.serialization.object({
    id: RoutineId,
    runbookId: RunbookId,
    name: core.serialization.string(),
    config: core.serialization.any(),
    ordinal: core.serialization.number(),
    type: RoutineType,
    createdBy: core.serialization.string(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
